import {
  NOT_REQUESTED,
  ON_DEMAND_SETTLEMENT_STATUS_MAPPER,
  SOFT_APPROVED,
} from './constants';

export const getOnDemandStatus = response => {
  const { isSoftApproved, status = '' } = response;
  // computing the status
  const result =
    ON_DEMAND_SETTLEMENT_STATUS_MAPPER[status.trim().toUpperCase()];

  const onDemandStatus = isSoftApproved
    ? SOFT_APPROVED
    : result || NOT_REQUESTED;
  return onDemandStatus;
};
